export const primaryBackground = "#FDFBF9";

export const primaryColor = "#CC4E30";

export const secondaryColor = "#93817E";

export const primaryForeground = "#fff";

// Export colors object for backward compatibility
export const colors = {
  primary: primaryColor,
  secondary: secondaryColor,
  background: primaryBackground,
  foreground: primaryForeground,
};
